import React, { createContext, useMemo, useState } from "react"

interface SignalRContextData {
    isConnected: boolean;
    setSignalRConnectionState: (value: boolean) => void;
}

export const SignalRContext = createContext<SignalRContextData>({
    isConnected: false,
    setSignalRConnectionState: () => { },
});

export const SignalRConnectionStateProvider: React.FC<{ children: React.ReactNode }> = ({
    children,
}) => {
    const [isConnected, setSignalRConnectionState] = useState<boolean>(false);
    const value = useMemo(() => ({ isConnected, setSignalRConnectionState }), [isConnected]);
    return (
        <SignalRContext.Provider value={value}>
            {children}
        </SignalRContext.Provider>
    );
};
